import CrudApiClient from '../crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from '../axios';
import { IStyleUploadInput, IStyleUploadRequest } from '@admin-panel/types';

class StyleUploadClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/sku/update-styles');
  }

  async search(query: any, page: number, size: number): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async create(payload: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async updateById(id: any, data: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findBulk(ids: any[]): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findById(id: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  // @ts-ignore
  async createMany(payload: Array<IStyleUploadInput>, meta: MetaQuery | undefined): Promise<any> {
    try {
      const request: IStyleUploadRequest = {
        entries: payload,
      };

      const response = await axiosInstance.post(`${this.baseURL}`, request);
      return this.transformList(response.data.data);
    } catch (error) {
      console.error(`Error creating entities in bulk:`, error);
      throw error;
    }
  }
}

export default StyleUploadClient;
